import * as React from "react";
import { E2EIdentifier } from "../../../e2e/E2EIdentifier";
import { Activity } from "../Common/components/Activity";
import { Overlay } from "../Common/components/Overlay";
import { Spinner } from "../Common/components/Spinner";
import { Wrapper } from "../Common/components/Wrapper";
import { IActivityMobile } from "./ActivityMobile";

export const ActivityMobileDefaultView = (props: IActivityMobile) => {
  if (!props.showing) {
    return null;
  }

  return (
    <Overlay>
      <Wrapper {...props}>
        <Activity data-e2e-id={E2EIdentifier.ACTIVITY_INDICATOR}>
          <Spinner />
        </Activity>
      </Wrapper>
    </Overlay>
  );
};
